module.exports = __webpack_public_path__ + "img/ed.c22e3512.png";